import { createContext, useContext } from 'react';
import { StateMachineReactContext } from 'fsm';
import {
  LowLevelAuthFlowMachineContext as LowLevelAuthFlowMachineContextType,
  LowLevelAuthFlowMachineEvent,
  LowLevelCustomAuthError,
} from './LowLevelAuthFlowMachineDefinition';

type MachineReactContext<
  AuthRequest,
  AuthResponse,
  AuthError extends LowLevelCustomAuthError = never,
> = StateMachineReactContext<
  LowLevelAuthFlowMachineContextType<AuthRequest, AuthResponse, AuthError>,
  LowLevelAuthFlowMachineEvent<AuthResponse, AuthError>
>;

export const LowLevelAuthFlowMachineContext = createContext<MachineReactContext<
  any,
  any,
  any
> | null>(null);

export function useLowLevelAuthFlowMachine<
  AuthRequest,
  AuthResponse,
  AuthError extends LowLevelCustomAuthError = never,
>() {
  const machine = useContext(LowLevelAuthFlowMachineContext);

  if (!machine) {
    throw new Error(
      'useLowLevelAuthFlowMachine must be used within a LowLevelAuthFlowMachineContext.Provider'
    );
  }

  return machine as MachineReactContext<AuthRequest, AuthResponse, AuthError>;
}
